<template>
  <div class="load-wrapper">
    <div class="load-bar">
      <div class="bar"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loader',
};
</script>

<style lang="scss" scoped>
  @import '../../node_modules/base-ui/src/scss/riseup-colors';

  .load-wrapper {
    width: 100%
  }

  .load-bar {
    position: relative;
    width: 100%;
    height: 6px;
    background-color: $riseup_gray_0;
  }
  .bar {
    content: "";
    display: inline;
    position: absolute;
    width: 0;
    height: 100%;
    left: 50%;
    text-align: center;
  }
  .bar:nth-child(1) {
    background-color: $riseup_mustard;
    animation: loading 3s linear infinite;
  }

  @keyframes loading {
    from {left: 50%; width: 0;}
    to {left: 0; width: 100%;}
  }

</style>
